<template>
  <div>
    <h3 style="margin-bottom: 0;">Edit Personal Summary</h3>
    <hr style="margin-bottom: 0px;">
    <p class="mt-2 mb-2">Sell yourself! This is what families will be seeing! What makes you great?</p>
    <textarea rows="10" class="form-control" v-model="notes"></textarea>
    <button class="mylisting-button secondary-button mt-3" @click="$emit('infoSaved')">Cancel</button>
    <button class="mylisting-button dark-button mt-3" @click="update()" style="float: right;">Update</button>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['user'],
  data() {
    return {
      notes: ''
    }
  },
  created() {
    this.notes = this.user.text15
  },
  methods: {
    update() {
      axios.patch(`/api/people/${this.user.id}/`, {
        text15: this.notes
      })
        .then(res => {
          this.$emit('infoSaved')
        })
        .catch(error => console.log(error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/candidates/profile/PersonalSummaryForm.vue